<span>{{ formattedDate() }}</span>